module.exports = __webpack_public_path__ + "img/right-arrow.418d3b75.svg";